// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable react/prop-types */
import React from 'react';
import Newspaper from '../../../../assets/newspaper.svg';

const articleLink = (category, slug) =>
	category[0]?.slug
		? `/resource-hub/${category[0]?.slug}/${slug}/`
		: `/resource-hub/${slug}/`;

const ArticleNav = ({ articleData }) => (
	<div className="flex article-nav">
		<div className="flex mx-auto overflow-hidden max-w-m-screen whitespace-nowrap">
			<h2 className="flex items-center px-3 pr-4 text-white">
				Latest articles
			</h2>
			<div className="py-4 overflow-hidden">
				<div className="flex flex-row gap-20 overflow-visible text-white animate-loop whitespace-nowrap">
					{articleData.map((article) => (
						<div key={article.title}>
							<img
								src={Newspaper}
								className="inline-block mr-2"
								alt="Newspaper icon"
							/>
							<span>{article.title}</span>
							<a
								href={articleLink(
									article.categories,
									article.slug
								)}
								target="_blank"
								rel="noreferrer"
								className="ml-3 text-base underline"
							>
								View article
							</a>
						</div>
					))}
				</div>
			</div>
		</div>
	</div>
);

export default ArticleNav;
